import React, { useEffect, useRef } from "react"
import { toast } from "react-toastify"
import { useTranslation } from "react-i18next"

import { Button } from "components"
import { editOrderPaymentDetails } from "services"

const OdpdSaveButton = props => {
  const {
    form,
    order,
    setOrders,
    sending,
    setSending,
    setEnableEdit
  } = props

  const [t] = useTranslation()

  const unmount = useRef(false)

  const handleSaveOrder = async () => {
    setSending(true)

    const data = {
      ...form,
      note: order.note || ""
    }

    try {
      await editOrderPaymentDetails(order._id, data)

      setOrders(prev =>
        prev.map(o =>
          o._id === order._id
            ? { ...o, ...form }
            : o
        )
      )

      if (unmount.current) return

      setEnableEdit(false)

      setSending(false)
    } catch (err) {
      console.log(err)

      toast.error(t("سفارش_ویرایش_نشد"))
    }

    if (unmount.current) return

    setSending(false)
  }

  useEffect(() => {
    unmount.current = false

    return () => { unmount.current = true }
  }, [])

  return (
    <Button
      color="success"
      loading={sending}
      onClick={handleSaveOrder}
    >
      {t("ذخیره")}
    </Button>
  )
}

export default OdpdSaveButton